module.exports = __webpack_public_path__ + "img/vcy_pic_wuneirong.1117dd22.png";